import React from 'react';
 
const AuthUserContext = React.createContext(JSON.parse(localStorage.getItem('authUser')));
 
export default AuthUserContext;